import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./View_address_modal.css";

const View_address_modal = (props) => {
  // console.log(props?.deliveryAddress, "props");

  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="View_address_modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Order Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="addp">
            <span>Mobile number:</span>
            {props?.data?.order?.users_address?.mobile_number}
          </p>
          <p className="addp">
            <span>Name of address:</span>{" "}
            {props?.data?.order?.users_address?.address_type}
          </p>
          <p className="addp">
            <span>Address:</span> {props?.data?.order?.users_address?.floor},{" "}
            {props?.data?.order?.users_address?.flat_home_bldg},{" "}
            {props?.data?.order?.users_address?.col_land_strt},{" "}
            {props?.data?.order?.users_address?.society_name},{" "}
            {props?.data?.order?.users_address?.area_name}
          </p>
          <p className="addp">
            <span>Subtotal:</span>₹{props?.data?.total_selling || 0}
          </p>
          <p className="addp">
            <span>Total Delivery Charges:</span>₹
            {props?.data?.total_delivery_charges || 0}
          </p>
          <p className="addp">
            <span>Coupon Discount:</span>₹{props?.data?.coupon_discount || 0}
          </p>
          <p className="addp">
            <span>Offer Discount:</span>₹{props?.data?.offer_discount || 0}
          </p>
          <p className="addp">
            <span>Tax Percent:</span>%{props?.data?.tax_percent || 0}
          </p>
          <p className="addp">
            <span>Total Tax:</span> ₹{props?.data?.total_tax || 0}
          </p>

          <p className="addp">
            <span>Total Addon:</span>₹{props?.data?.total_addon || 0}
          </p>
          <p className="addp">
            <span>Total Amount:</span>₹{props?.data?.total_amount || 0}
          </p>

          {/* <p className="addp">
            <span>Coupon Name:</span>
            {props?.data?.total_amount || 0}
          </p> */}

          <p className="addp">
            <span>Add On:</span>{" "}
            {props?.data?.order_addOns
              ?.map((val) => val?.product_addOn?.name)
              ?.filter(Boolean)
              ?.join(", ")}
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default View_address_modal;
